module.exports = __webpack_public_path__ + "static/media/carta_57.32205ff0.jpg";